export default __webpack_public_path__ + "static/media/26.fd15cc8d.jpg";